export function preferencesReportsJson (language) {
  let items

  if (language === 'es') {
    items = {
      reports: {
        name: 'reports',
        label: 'activar alertas'
      }
    }
  } else if (language === 'en') {
    items = {
      reports: {
        name: 'reports',
        label: 'activate alerts'
      }
    }
  }

  return (items)
}
